// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2PSsl","content":"LoadingAlert_content__2MlFk"};